import { c as _c } from "react/compiler-runtime";
import { MemberRoleMenuButton } from "@components/table/members/member-role-menu-button";
import { RemoveMemberFromTeamMenuButton } from "@components/table/teams/remove-member-from-team-menu-button";
import { RemoveTeamMenuButton } from "@components/table/teams/remove-team-menu-button";
import { DeleteIcon, SelectionIcon, UserRoleIcon, VisibleIcon } from "@flat-ui";
import { useTeamsAccess } from "@hooks/access-control/use-teams-access";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useTeamUtils } from "@hooks/use-team-utils";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { toggleItemSelection } from "@utils/array-utils";
/**
 * Custom hook to get the menu options for a team.
 * Provides actions for selecting, viewing details, changing role, and removing a team.
 */
export function useTeamMenuOptions(t0) {
  const $ = _c(34);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    shouldExcludeRemove: t2,
    memberToRemove,
    shouldConfirmTeamRoleChange: t3
  } = t1;
  const shouldExcludeRemove = t2 === undefined ? false : t2;
  const shouldConfirmTeamRoleChange = t3 === undefined ? false : t3;
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  const {
    openTeamDetails
  } = useTeamUtils();
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    canChangeTeamRole,
    canDeleteTeams,
    canDeleteMembersFromTeam
  } = useTeamsAccess();
  let t4;
  if ($[2] !== dispatch || $[3] !== selectedRowIds) {
    t4 = team => {
      const newSelectedRowIds = toggleItemSelection(selectedRowIds, team.id);
      dispatch(setInitialFetchingItems(newSelectedRowIds));
    };
    $[2] = dispatch;
    $[3] = selectedRowIds;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isScreenSmOrSmaller) {
    t5 = () => isScreenSmOrSmaller;
    $[5] = isScreenSmOrSmaller;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isScreenSmOrSmaller || $[8] !== t4 || $[9] !== t5) {
    t6 = {
      label: "Select team",
      Icon: SelectionIcon,
      onSelect: t4,
      shouldShow: t5,
      shouldShowDividerAfter: isScreenSmOrSmaller
    };
    $[7] = isScreenSmOrSmaller;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== openTeamDetails) {
    t7 = {
      label: "View details",
      Icon: VisibleIcon,
      onSelect: team_0 => {
        openTeamDetails({
          teamId: team_0.id,
          numberOfMembers: team_0.memberCount
        });
      },
      shouldShowDividerAfter: true
    };
    $[11] = openTeamDetails;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== companyId || $[14] !== shouldConfirmTeamRoleChange) {
    t8 = (team_1, onMenuClose) => <MemberRoleMenuButton member={team_1} companyId={companyId} subjectType="team" teamName={shouldConfirmTeamRoleChange ? team_1.name : undefined} onMenuClose={onMenuClose} />;
    $[13] = companyId;
    $[14] = shouldConfirmTeamRoleChange;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== canChangeTeamRole) {
    t9 = () => canChangeTeamRole;
    $[16] = canChangeTeamRole;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = {
      label: "Change role",
      Icon: UserRoleIcon,
      component: t8,
      shouldShow: t9,
      shouldShowDividerAfter: true
    };
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== canDeleteTeams || $[22] !== shouldExcludeRemove) {
    t11 = {
      label: "Remove team",
      Icon: DeleteIcon,
      component: _temp,
      shouldShow: team_3 => !shouldExcludeRemove && canDeleteTeams && !team_3.category.isManaged
    };
    $[21] = canDeleteTeams;
    $[22] = shouldExcludeRemove;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== canDeleteMembersFromTeam || $[25] !== companyId || $[26] !== memberToRemove) {
    t12 = memberToRemove ? [{
      label: "Remove from team",
      Icon: DeleteIcon,
      component: (team_4, onMenuClose_1) => <RemoveMemberFromTeamMenuButton companyId={companyId} team={team_4} member={memberToRemove} onMenuClose={onMenuClose_1} />,
      shouldShow: team_5 => canDeleteMembersFromTeam && !team_5.category.isManaged
    }] : [];
    $[24] = canDeleteMembersFromTeam;
    $[25] = companyId;
    $[26] = memberToRemove;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t6 || $[32] !== t7) {
    t13 = [t6, t7, t10, t11, ...t12];
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t6;
    $[32] = t7;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}
function _temp(team_2, onMenuClose_0) {
  return <RemoveTeamMenuButton team={team_2} onMenuClose={onMenuClose_0} />;
}